import { FC } from 'react';

import { DOT, VACANCY_ID } from 'utils/constants/common';

import { Divider, HSpacing, Link, Text, useBreakpoint, VSpacing } from '@hh.ru/magritte-ui';
import { ArrowSquareOutlinedSize16 } from '@hh.ru/magritte-ui/icon';

import { NotAvailableVacancy } from 'components/MultiCreationAuction/VacanciesTable/NotAvailableForCreationModal/NotAvailableForCreationModal';

import styles from 'components/MultiCreationAuction/VacanciesTable/NotAvailableForCreationModal/NotAvailableForCreationVacancy/NotAvailableForCreationVacancy.module.less';

interface NotAvailableForCreationVacancyProps {
    vacancy: NotAvailableVacancy;
    isLastItem: boolean;
    status: string;
}

export const NotAvailableForCreationVacancy: FC<NotAvailableForCreationVacancyProps> = ({
    vacancy,
    isLastItem,
    status,
}) => {
    const { vacancyId, name, areaName, isUnknownVacancy } = vacancy;

    const { isMobile } = useBreakpoint();

    const horizontalDotDivider = (
        <Text style="secondary" typography="label-3-regular">
            <HSpacing default={4} />
            {DOT}
            <HSpacing default={4} />
        </Text>
    );

    const vacancyIdContent = `${VACANCY_ID} ${vacancyId}`;

    const isUnknownVacancyContent = (
        <div className={styles.vacancyInfo}>
            <Text style="primary" typography="label-2-regular">
                {vacancyIdContent}
            </Text>
            <Text style="warning" typography="label-2-regular">
                {status}
            </Text>
        </div>
    );

    const toCampaignLink = (
        <Link
            href={`/new/campaign/auction/vacancy/${vacancyId}`}
            iconRight={<ArrowSquareOutlinedSize16 />}
            mode="secondary"
            style="neutral"
            target="_blank"
        />
    );

    return (
        <div>
            <VSpacing default={16} />
            {isUnknownVacancy ? (
                isUnknownVacancyContent
            ) : (
                <div className={styles.content}>
                    <div className={styles.vacancyInfo}>
                        <div>
                            <Text style="primary" typography="label-2-regular">
                                {name}
                            </Text>
                            <div className={styles.vacancySecondaryInfo}>
                                {!isMobile && (
                                    <>
                                        {toCampaignLink}
                                        {horizontalDotDivider}
                                    </>
                                )}
                                <Text style="secondary" typography="label-3-regular">
                                    {vacancyIdContent}
                                </Text>
                                {horizontalDotDivider}
                                <Text style="secondary" typography="label-3-regular">
                                    {areaName}
                                </Text>
                            </div>
                        </div>
                        <Text style="warning" typography="label-2-regular">
                            {status}
                        </Text>
                    </div>
                    {isMobile && toCampaignLink}
                </div>
            )}
            <VSpacing default={16} />
            {!isLastItem && <Divider />}
        </div>
    );
};
